import Highlights from './Highlights.container';
export default Highlights;
